import React, { useEffect, useRef, useState } from "react";
import "../styles/Review.css";
import AnimatedTitle from "../components/AnimatedTitle";

import AOS from "aos";
import "aos/dist/aos.css";

// Review images
import r1 from "../assets/r1.png";
import r2 from "../assets/r2.png";
import r3 from "../assets/r3.png";
import r4 from "../assets/r4.png";
import r5 from "../assets/r5.png";
import r6 from "../assets/r6.png";
import r7 from "../assets/r7.png";
import r8 from "../assets/r8.png";
import r9 from "../assets/r9.png";
import r10 from "../assets/r10.png";
import r11 from "../assets/r11.png";
import r12 from "../assets/r12.png";

// Downside images
import bigSquare from "../assets/tt12.jpeg";
import portraitImg from "../assets/qr.jpeg";

// Logo
import logo from "../assets/van-logo.png";

const reviews = [
  r1, r2, r3, r4, r5, r6,
  r7, r8, r9, r10, r11, r12
];

const Review = () => {
  const sliderRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollStart = useRef(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    document.title =
      "Mahacabs | Best Tempo Traveller  | Maha Cabs Mayiladuthurai";

    const setMeta = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    setMeta(
      "description",
      "Read genuine customer reviews of Maha Cabs — Best Tempo Traveller service in Mayiladuthurai. Trusted by families, groups, temple tours, and hill trips with safe and comfortable 18-seater AC vans."
    );

    setMeta(
      "keywords",
      "best tempo traveller reviews mayiladuthurai, maha cabs reviews, 18 seater tempo traveller review, tempo traveller customer feedback, mayiladuthurai tempo traveller rating"
    );
  }, []);
  // ==================================

  // ===== Position-aware hover logic =====
  const handleMove = (e) => {
    const btn = e.currentTarget;
    const circle = btn.querySelector(".maha-posaware-circle");

    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    circle.style.left = x + "px";
    circle.style.top = y + "px";
  };

  // Auto scroll
  useEffect(() => {
    const slider = sliderRef.current;
    let interval;

    if (!isHovered) {
      interval = setInterval(() => {
        slider.scrollLeft += 320;

        if (slider.scrollLeft >= slider.scrollWidth - slider.clientWidth) {
          slider.scrollLeft = 0;
        }
      }, 2500);
    }

    return () => clearInterval(interval);
  }, [isHovered]);

  // AOS init
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  const slideLeft = () => {
    sliderRef.current.scrollBy({ left: -320, behavior: "smooth" });
  };

  const slideRight = () => {
    sliderRef.current.scrollBy({ left: 320, behavior: "smooth" });
  };

  const handleMouseDown = (e) => {
    isDragging.current = true;
    startX.current = e.pageX - sliderRef.current.offsetLeft;
    scrollStart.current = sliderRef.current.scrollLeft;
  };

  const handleMouseLeave = () => {
    isDragging.current = false;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();

    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (x - startX.current) * 1.8;
    sliderRef.current.scrollLeft = scrollStart.current - walk;
  };

  return (
    <div className="review-section">
      <div className="review-logo">
        <img
          src={logo}
          alt="Maha Cabs Tempo Traveller Logo Mayiladuthurai"
        />
      </div>

      <AnimatedTitle
        text="WHAT PEOPLE SAY ABOUT MAHA CABS"
        className="review-title"
      />

      <div className="review-wrapper">
        <div className="mobile-arrow-row">
          <div className="center-con left-arrow" onClick={slideLeft}>
            <div className="round">
              <div id="cta">
                <span className="arrow primera prev1"></span>
                <span className="arrow segunda prev1"></span>
              </div>
            </div>
          </div>

          <div className="center-con right-arrow" onClick={slideRight}>
            <div className="round">
              <div id="cta">
                <span className="arrow primera next1"></span>
                <span className="arrow segunda next1"></span>
              </div>
            </div>
          </div>
        </div>

        <div
          className="review-slider"
          ref={sliderRef}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onMouseDown={handleMouseDown}
          onMouseLeaveCapture={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          {reviews.concat(reviews).map((img, index) => (
            <div
              className="review-card"
              key={index}
              data-aos="fade-up"
              data-aos-delay={(index % reviews.length) * 40}
            >
              <img
                src={img}
                alt="Customer review for Maha Cabs Tempo Traveller in Mayiladuthurai"
                draggable="false"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Downside section */}
      <div className="downside-section">
        <div className="downside-grid">
          <div className="left-box" data-aos="fade-right">
            <img
              src={bigSquare}
              alt="18 seater AC Tempo Traveller in Mayiladuthurai - Maha Cabs"
            />
          </div>

          <div className="right-box" data-aos="fade-left">
            <img
              src={portraitImg}
              alt="Maha Cabs Google Reviews QR Code Mayiladuthurai"
              className="portrait-img"
            />

            <div className="or-divider">
              <span className="dash">—</span>
              <span className="or-text">OR</span>
              <span className="dash">—</span>
            </div>

            <button
              className="feedback-btn maha-posaware-btn"
              onMouseEnter={handleMove}
              onMouseLeave={handleMove}
              onClick={() =>
                window.open(
                  "https://maps.app.goo.gl/WtgjwnBq6bTT8BXF7?g_st=aw",
                  "_blank"
                )
              }
              aria-label="Leave Google Review for Maha Cabs Tempo Traveller"
            >
              <span className="maha-posaware-circle"></span>
              GIVE YOUR FEEDBACK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
